import {Typography} from '@sollapay/ui';
import {Button} from '@sollapay/ui/components';

import type {FC} from 'react';

export interface ShareRowConfirmProps {
  message: string;
  confirmLabel: string;
  backLabel: string;
  isBusy: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

/** A destructive change confirmed inside its list row, under the person it's about. */
export const ShareRowConfirm: FC<ShareRowConfirmProps> = ({
  message,
  confirmLabel,
  backLabel,
  isBusy,
  onConfirm,
  onCancel
}) => (
  <div
    role="alert"
    data-slot="share-row-confirm"
    className="ms-11 flex flex-wrap items-center gap-2 rounded-md border border-border-error bg-background-error px-3 py-2.5"
  >
    <Typography size="sm" className="min-w-48 flex-1 whitespace-normal">
      {message}
    </Typography>
    <Button size="sm" destructive isLoading={isBusy} onClick={onConfirm}>
      {confirmLabel}
    </Button>
    <Button size="sm" variant="secondary" disabled={isBusy} onClick={onCancel}>
      {backLabel}
    </Button>
  </div>
);
